'use strict';var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||!1;descriptor.configurable=!0;if('value'in descriptor)descriptor.writable=!0;Object.defineProperty(target,descriptor.key,descriptor)}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor}}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const d3=require('d3');
const BaseControllerBackedDirective=require('../../../../dist-es6/client/angularCommon/baseControllerBackedDirective');
const BaseResizableDirectiveController=require('../../../../dist-es6/client/angularCommon/baseResizableDirectiveController');let

TextTicksDirective=function(_BaseControllerBacked){_inherits(TextTicksDirective,_BaseControllerBacked);function TextTicksDirective(){_classCallCheck(this,TextTicksDirective);return _possibleConstructorReturn(this,_BaseControllerBacked.apply(this,arguments))}_createClass(TextTicksDirective,[{key:'objectBindings',get:function()
{
return['tickProvider','tickFormatter','axis','fontSize'];
}},{key:'textBindings',get:function()

{
return['textAnchor'];
}},{key:'controller',get:function()

{
return TextTicksDirectiveController;
}}]);return TextTicksDirective}(BaseControllerBackedDirective);let


TextTicksDirectiveController=function(_BaseResizableDirecti){_inherits(TextTicksDirectiveController,_BaseResizableDirecti);_createClass(TextTicksDirectiveController,null,[{key:'$inject',get:function()
{return['$scope','$element','$window']}}]);

function TextTicksDirectiveController($scope,$element,$window){_classCallCheck(this,TextTicksDirectiveController);var _this2=_possibleConstructorReturn(this,
_BaseResizableDirecti.call(this,$scope,$element,$window));
_this2._svgElement=null;
$scope.$watch('controller.axis',function(){
if(_.exists(_this2.axis)){
let dimensionToWatch=_this2.axis.orientation==='horizontal'?'width':'height';
$scope.$watch(`controller.dimensions.${dimensionToWatch}`,function(){return _this2._render()});
$scope.$watch('controller.axis.scale',function(){return _this2._render()});
}
});return _this2;
}TextTicksDirectiveController.prototype.

_render=function _render(){
if(!this._dimensionsValid){
return;
}

if(!_.exists(this.axis)||!_.exists(this.axis.scale)){
return;
}

this._refreshSvg();

let ticks=this.tickProvider(this.axis);

let tickAxis=d3.svg.axis().
scale(this.axis.scale).
orient(this.axis.orientation==='horizontal'?'top':'right').
tickFormat(this.tickFormatter);

switch(ticks.type){
case'values':
tickAxis=tickAxis.tickValues(ticks.values);
break;
case'd3Calculated':
tickAxis=tickAxis.ticks(d3.time[ticks.interval],ticks.step);
break;
default:
throw new Error('unknown ticks type');}


let axisElements=d3.select(this._svgElement).append('g').
attr('transform',`translate(0, ${this.axis.orientation==='horizontal'?this.fontSize:0})`).
attr('class','text-ticks').
call(tickAxis);

axisElements.selectAll('text').
attr({
x:'0',
y:'0'}).

style({
"font-size":`${this.fontSize}px`,
"text-anchor":this.textAnchor||'start'});

axisElements.selectAll('path').remove();
};TextTicksDirectiveController.prototype.

_refreshSvg=function _refreshSvg(){
if(_.exists(this._svgElement)){
angular.element(this._svgElement).remove();
}

this._$element.append(`<svg width="${this.dimensions.width}" height="${this.dimensions.height}"></svg>`);
this._svgElement=this._$element[0].getElementsByTagName('svg')[0];
};return TextTicksDirectiveController}(BaseResizableDirectiveController);


module.exports=TextTicksDirective;
//# sourceMappingURL=textTicksDirective.js.map
